module.exports = __webpack_public_path__ + "img/untitled-font-1.92214d5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/untitled-font-1.svg
// module id = ./src/assets/fonts/untitled-font-1.svg
// module chunks = 34